import useUserData from 'hooks/useUserData';
import { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isQuestionAssignedToMe, isQuestionAssignedToOthers } from '../helpers';
import { useMyHubQuery } from '../queries';
import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';

function useMyQuestions() {
  const { user, companyId } = useUserData();
  const { hash } = useLocation();
  const {
    tasks: questions,
    isLoading,
    isIdle,
    refetch,
  } = useMyHubQuery({
    companyId,
    username: user?.username || '',
    articleType: ArticleSourceType.QUESTION,
  });
  const [tab, setTab] = useState<string>(
    decodeURIComponent(hash).replace('#', '') || 'assigned-to-me',
  );
  const countTasks = useMemo(() => {
    let totaltasks: Record<string, number> = {};
    if (user) {
      questions.forEach((question) => {
        if (isQuestionAssignedToMe({ question, user })) {
          totaltasks['assigned-to-me'] = totaltasks['assigned-to-me']
            ? totaltasks['assigned-to-me'] + 1
            : 1;
        } else if (isQuestionAssignedToOthers({ question, user })) {
          totaltasks['assigned-to-others'] = totaltasks['assigned-to-others']
            ? totaltasks['assigned-to-others'] + 1
            : 1;
        }
      });
    }

    return totaltasks;
  }, [questions]);
  const tasksData = useMemo(() => {
    let tasksData = [...questions];

    if (user) {
      switch (tab) {
        case 'assigned-to-me': {
          tasksData = questions.filter((question) => isQuestionAssignedToMe({ question, user }));
          break;
        }

        case 'assigned-to-others': {
          tasksData = questions.filter((question) =>
            isQuestionAssignedToOthers({ question, user }),
          );
          break;
        }

        default: {
          tasksData = [...questions];
        }
      }
    }

    return tasksData;
  }, [questions, tab]);

  return {
    countTasks,
    isIdle,
    isLoading,
    tab,
    tasksData,
    refetch,
    setTab,
  };
}

export default useMyQuestions;
